import { render, staticRenderFns } from "./WalletPicker.vue?vue&type=template&id=0dbfa550&scoped=true"
import script from "./WalletPicker.vue?vue&type=script&lang=js"
export * from "./WalletPicker.vue?vue&type=script&lang=js"
import style0 from "./WalletPicker.vue?vue&type=style&index=0&id=0dbfa550&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbfa550",
  null
  
)

export default component.exports